import { useState } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import Callout from 'modules/core/components/Callout'
import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import Footer from './Footer'
import FormFields from './FormFields'
import type { FormData, ValidStepChurn } from './types'

interface Props {
  onClose: () => void
}

const DeleteCompanyModal = ({ onClose }: Props) => {
  const [step, setStep] = useState<ValidStepChurn>('first-step')
  const [formData, setFormData] = useState<FormData>({
    mainReason: undefined,
    secondaryReason: undefined,
  })
  const title = i18n.t('common.cancel_company_subscription.modal.title')
  const description = i18n.t('common.cancel_company_subscription.modal.description')

  const getValue = (attr: keyof FormData) => formData[attr]
  const onChange = (values: FormData) => setFormData({ ...formData, ...values })

  return (
    <Modal
      illustration="contact-us"
      title={title}
      description={description}
      onClose={onClose}
      footer={<Footer step={step} setStep={setStep} getValue={getValue} onClose={onClose} />}
    >
      <Box gap="s32">
        <Box gap="s16">
          <Text.Normal>
            {i18n.t('common.cancel_company_subscription.modal.reason_question')}
          </Text.Normal>
          <FormFields getValue={getValue} onChange={onChange} step={step} />
          {step === 'second-step' && (
            <Callout type="warning" description={i18n.t('billing.churn_request.callout')} />
          )}
        </Box>
      </Box>
    </Modal>
  )
}

export default DeleteCompanyModal
